import StarIcon from './star'
import StarActiveIcon from './star-active'
import StarBigIcon from './star-big'
import StarBigActiveIcon from './star-big-active'
import ClockIcon from './clock'
import UserIcon from './user'
import CheckIcon from './check'
import ArrowLeftIcon from './arrow-left'
import ArrowRightIcon from './arrow-right'
import PlusIcon from './plus'
import DoneIcon from './done'
import PinIcon from './pin';
import MobileIcon from './mobile/index.';
import EmailIcon from './email';
import GoIcon from './go';
import NumberIcon from './number';
import CalendarIcon from './calendar';
import PdfIcon from './pdf';
import SchoolCalendarIcon from './school_calendar';
// import ArrowRightIcon from './arrow-right';
import Check from './check';
import MoreIcon from './more';
import Calendar2Icon from './calendar2';
import BarsIcon from './bars';
import CloseIcon from './close';
import DownloadIcon from './download';
import HomeIcon from './home'
import CrumbsRightIcon from './crumbs-right'
import TagIcon from './tag'
import ExclamationIcon from './exclamation'
import RhombusIcon from './rhombus'
import SchoolsIcon from './schools'
import ChamomileIcon from './chamomile'


export default {
  StarIcon,
  StarActiveIcon,
  ClockIcon,
  UserIcon,
  CheckIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  PlusIcon,
  DoneIcon,
  StarBigIcon,
  StarBigActiveIcon,
  PinIcon,
  MobileIcon,
  EmailIcon, 
  GoIcon,
  NumberIcon,
  CalendarIcon,
  PdfIcon,
  SchoolCalendarIcon,
//   ArrowRightIcon,
  Check,
  MoreIcon,
  Calendar2Icon,
  BarsIcon,
  CloseIcon,
  DownloadIcon,
  HomeIcon,
  CrumbsRightIcon,
  TagIcon,
  ExclamationIcon,
  RhombusIcon,
  SchoolsIcon,
  ChamomileIcon,
}